import { Standard } from '@lemsar/common/domains/models/standard';
import { Institution } from '@lemsar/institution/domains/model/institution';
import { SubVocational } from '@lemsar/common/domains/models/sub-vocational';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    20/06/2018
 */
export class Program {
    public id: string;
    public name: string;
    public yearlyCapacity: number;
    public standard: Standard;
    public subVocational: SubVocational;
    public institution: Institution;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/program.ts